import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { Alert, Form, Table, Dropdown, DropdownButton } from 'react-bootstrap';
import {
  faChalkboardTeacher,
  faPlus,
  faBookOpen,
  faPuzzlePiece,
  faChalkboard,
  faPlusSquare
} from '@fortawesome/free-solid-svg-icons';
import { Button } from '@material-ui/core';
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteIcon from '@material-ui/icons/Delete';
import Modal from '@material-ui/core/Modal';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { Tab, Tabs, TabPanel, TabList } from 'react-tabs';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import { purple, red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import { Favorite, Share, ExpandMore, MoreVert, Add } from '@material-ui/icons';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _isEmpty from 'lodash/isEmpty';
import _capitalize from 'lodash/capitalize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';
import { truncate } from 'lodash';
import {
  Container,
  Wrapper,
  HomeButtons,
  SmallButton
} from '../../styles/HomeStyles';
import Header from '../header/Header';
import { FormWrapper, Label } from '../../styles/LoginStyles';
import Dimage from '../../assets/3D-printing.jpg';
import {
  DashboardWrapper,
  ButtonWrapper,
  ContentWrapper,
  TextWrapper,
  ControlButtonWrapper,
  ActionButtons,
  UserLabel,
  TableWrapper,
  NormalText,
  WideNormalText
} from '../../styles/DashboardStyles';
import { SwitchButton, InputWrapper, Row } from '../../styles/InstructorStyles';
import { config } from '../../config';
import { styles } from '../../styles/TabStyles';
import { Toast } from '../student/Home';

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  accordion: {
    width: '70%',
    alignContent: 'center',
    textAlign: 'center'
  },
  tabTextColor: {
    backgroundColor: '#4287cc'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  form: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch'
    }
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  modal: {
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  media: {
    height: 0,
    paddingTop: '56.25%' // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  avatar: {
    backgroundColor: red[500]
  }
}));

export default function InstructorDashboard() {
  const history = useHistory();
  const classes = useStyles();

  const [modalStyle] = React.useState(getModalStyle);

  const [state, setState] = useState({
    toggle: false
  });

  const { t } = useTranslation();
  const [approvedAdmins, setApprovedAdmins] = useState([]);
  const [currency, setCurrency] = useState('EUR');

  const handleCurrencyChange = event => {
    setCurrency(event.target.value);
  };

  const [tabIndex, setTabIndex] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [currentSelected, setCurrentSelected] = useState({});
  const [tabValue, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCategories, setCurrentCategories] = useState([]);
  const [currentCourseObj, setCurrentCourseObj] = useState([]);
  const [currentCourses, setCurrentCourses] = useState([]);
  const [currentSections, setCurrentSections] = useState([]);
  const [currentLectures, setCurrentLectures] = useState([]);
  const [myCourses, setMyCourses] = useState([]);
  const [courseEditName, setCourseEditName] = useState('');
  const [edit, setEdit] = useState(null);
  const [editSection, setEditSection] = useState(null);
  const [editCourseKey, setEditCourseKey] = useState(null);
  const [editLecture, setEditLecture] = useState(null);

  const [courseEditDescription, setCourseEditDescription] = useState('');
  const [sectionEditDescription, setSectionEditDescription] = useState('');
  const [sectionEditName, setSectionEditName] = useState('');
  const [lectureEditDescription, setLectureEditDescription] = useState('');
  const [lectureEditName, setLectureEditName] = useState('');
  const [lectureEditLink, setLectureEditLink] = useState('');

  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertFailure, setAlertFailure] = useState(false);

  const [category, setCategory] = useState(null);
  const [course, setCourse] = useState(null);
  const [currentCourse, setCurrentCourse] = useState(null);
  const [currentCourseName, setCurrentCourseName] = useState(null);
  const [section, setSection] = useState('');
  const [video, setVideo] = useState(null);
  const [courseDescription, setCourseDescription] = useState('');
  const [lectureName, setLecture] = useState('');
  const [lectureLink, setLectureLink] = useState('');
  const [lectureDescription, setLectureDescription] = useState('');
  const [sectionDescription, setSectionDescription] = useState('');
  const [categoryInput, setCategoryInput] = useState('');
  const [courseInput, setCourseInput] = useState('');
  const [sectionInput, setSectionInput] = useState('');

  const [categoryid, setCategoryId] = useState(null);
  const [courseid, setCourseId] = useState(null);
  const [sectionid, setSectionId] = useState(null);

  const [addNew, setAddNew] = useState(false);
  const [addNewCourse, setAddNewCourse] = useState(false);
  const [addNewSection, setAddNewSection] = useState(false);
  const [status, setStatus] = useState(false);
  const [videoModalShow, setVideoModalShow] = useState(false);
  const [successModalShow, setSuccessModalShow] = useState(false);
  const [displayLectures, setDisplayLectures] = useState(true);

  const showLectures = () => {
    setDisplayLectures(true);
  };

  const showStats = () => {
    setDisplayLectures(false);
  };

  const handleAccordionChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setAddNewCourse(false);
    setAddNewSection(false);
  };

  const handleValueChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const uid = localStorage.getItem('userId');
    axios
      .all([
        axios.get(`${config.API_URL}course/categories/all/${uid}`),
        axios.get(`${config.API_URL}course/instructor/courses/${uid}`),
        axios.get(`${config.API_URL}course/instructor/sections/${uid}`),
        axios.get(`${config.API_URL}course/instructor/lectures/${uid}`),
        axios.get(`${config.API_URL}course/instructor/${uid}/myCourses`)
      ])
      .then(
        axios.spread((obj1, obj2, obj3, obj4, obj5) => {
          setCurrentCategories(_get(obj1, 'data.data', []));
          setCurrentCourses(_get(obj2, 'data.data.decision', []));
          setCurrentSections(_get(obj3, 'data.data.decision', []));
          setCurrentLectures(_get(obj4, 'data.data.decision', []));
          setMyCourses(_get(obj5, 'data.data', []));
        })
      );
  }, [alertSuccess, status]);

  useEffect(() => {
    const uid = localStorage.getItem('userId');
    axios
      .get(`${config.API_URL}course/instructor/${uid}/course/${currentCourse}`)
      .then(response => {
        setCurrentCourseObj(_get(response, 'data.data', []));
        // setStatus('You have successfully added the category');
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  }, [currentCourse, status]);

  const addCategory = () => {
    setCategoryInput('');
    const uid = localStorage.getItem('userId');
    const categoryData = {
      userid: uid,
      name: categoryInput === '' ? category.name : categoryInput,
      description: 'Sample Description'
    };
    axios
      .post(`${config.API_URL}course/instructor/addCategory`, categoryData)
      .then(response => {
        setStatus('You have successfully added the category');
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const addCourse = categoryId => {
    setCourse('');
    setCourseDescription('');
    const uid = localStorage.getItem('userId');
    const courseData = {
      userid: uid,
      name: course,
      description: courseDescription,
      categoryid: categoryId
    };
    axios
      .post(`${config.API_URL}course/instructor/addCourse`, courseData)
      .then(response => {
        console.log(response, 'response');

        setAddNewCourse(false);
        setAddNew(false);
        setAddNewSection(false);
        setStatus(`You have successfully added the course ${course}`);
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const AntSwitch = withStyles(theme => ({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex'
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      '&$checked': {
        transform: 'translateX(12px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
          borderColor: theme.palette.primary.main
        }
      }
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none'
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white
    },
    checked: {}
  }))(Switch);

  const addSection = () => {
    setSectionInput('');
    const uid = localStorage.getItem('userId');
    const sectionData = {
      userid: uid,
      name: section,
      description: sectionDescription,
      courseid: currentCourse
    };
    axios
      .post(`${config.API_URL}course/instructor/addSection`, sectionData)
      .then(response => {
        console.log(response, 'response');
        setAddNewCourse(false);
        setAddNew(false);
        setAddNewSection(false);
        setStatus(`You have successfully added the section ${section}`);
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('There was a problem adding the section');
        setAlertFailure(true);
      });
  };

  const addLecture = sectionId => {
    const uid = localStorage.getItem('userId');
    const lectureData = {
      userid: uid,
      name: lectureName,
      description: lectureDescription,
      sectionid: sectionId,
      link: lectureLink
    };
    if (lectureLink.startsWith('https://www.youtube.com')) {
      axios
        .post(`${config.API_URL}course/instructor/addLecture`, lectureData)
        .then(response => {
          console.log(response, 'response');
          setStatus('You have successfully added the lecture');
          setAlertSuccess(true);
          setLecture('');
          setLectureLink('');
          setLectureDescription('');
          // setSuccessModalShow(true);
          setAddNew(false);
        })
        .catch(error => {
          console.log(error, 'errr');
          setStatus('error');
        });
    } else {
      setStatus('Link needs to be a valid Youtube Link!');
      setAlertFailure(true);
    }
  };

  const showVideo = index => {
    setVideo(index);
    setVideoModalShow(true);
  };

  const VideoModal = props => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {video && video.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReactPlayer style={{ width: 800 }} url={video && video.link} />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const SuccessModal = props => {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Success!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{status}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const handleChange = event => {
    setState({ ...state, [event.target.name]: event.target.checked });
    // setToggle(event.target.name)
  };

  const editCourse = (name, description, cid) => {
    const uid = localStorage.getItem('userId');
    const courseData = {
      name,
      description
    };
    console.log(name, description);
    axios
      .put(
        `${config.API_URL}course/instructor/${uid}/crs/${cid}/editCourseDetails`,
        courseData
      )
      .then(response => {
        console.log(response, 'response');
        setEdit(null);
        setStatus('Course Details Updated!');
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const editSectionFunc = (name, description, cid, sid) => {
    const uid = localStorage.getItem('userId');
    const sectionData = {
      name,
      description
    };
    console.log(sectionData, uid, 'userid', cid, 'coyrseid', sid, 'sectionid');
    axios
      .put(
        `${config.API_URL}course/instructor/${uid}/crs/${cid}/sc/${sid}/editSectionDetails`,
        sectionData
      )
      .then(response => {
        console.log(response, 'response');
        setEditSection(null);
        setStatus('Section Details Updated!');
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const editLectureFunc = (name, description, link, cid, sid, lid) => {
    const uid = localStorage.getItem('userId');
    const lectureData = {
      name,
      description,
      link
    };
    console.log(lectureData);
    if (link.startsWith('https://www.youtube.com')) {
      axios
        .put(
          `${
            config.API_URL
          }course/instructor/${uid}/sc/${sid.toString()}/lc/${lid.toString()}/editLectureDetails`,
          lectureData
        )
        .then(response => {
          console.log(response, 'response');
          setEditLecture(null);
          setStatus('Lecture Details Updated!');
          setAlertSuccess(true);
        })
        .catch(error => {
          console.log(error, 'errr');
          setStatus('error');
        });
    } else {
      setStatus('Link needs to be a valid Youtube Link!');
      setAlertFailure(true);
    }
  };

  const changeCourseType = (cid, ctype) => {
    const uid = localStorage.getItem('userId');
    const courseData = {
      courseid: cid
    };
    axios
      .post(`${config.API_URL}course/admin/course/type`, courseData)
      .then(response => {
        console.log(response, 'response');
        setStatus(
          `Course type changed to ${ctype === 'free' ? 'paid' : 'free'}`
        );
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const deleteCourse = index => {
    const uid = localStorage.getItem('userId');
    setShowDelete(false);
    const courseData = {
      courseid: index.courseid
    };

    console.log(courseData, 'delete courr');
    axios
      .put(`${config.API_URL}course/admin/${uid}/removeCourse`, courseData)
      .then(response => {
        console.log(response, 'course delete response');
        setStatus(`You have successfully deleted the course ${index.name}`);
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const deleteSection = index => {
    const uid = localStorage.getItem('userId');
    setShowDelete(false);
    console.log(index.sectionid, 'delete courr');
    axios
      .delete(`${config.API_URL}course/delete/section/${index.sectionid}`)
      .then(response => {
        console.log(response, 'section delete response');
        setStatus(`You have successfully deleted the section ${index.name}`);
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus(error.message);
        setAlertFailure(true);
      });
  };

  const deleteLecture = index => {
    const uid = localStorage.getItem('userId');
    setShowDelete(false);
    axios
      .delete(`${config.API_URL}course/delete/lecture/${index.lectureid}`)
      .then(response => {
        console.log(response, 'lecture delete response');
        setStatus(`You have successfully deleted the lecture ${index.name}`);
        setAlertSuccess(true);
        // setSuccessModalShow(true);
      })
      .catch(error => {
        console.log(error, 'errr');
        setStatus('error');
      });
  };

  const categoryAccordionView = () => {
    return (
      <Grid container justify="center">
        <div className={classes.accordion}>
          {currentCategories.map((index, key) => {
            return (
              <Accordion
                expanded={expanded === `panel${key}`}
                onChange={handleAccordionChange(`panel${key}`)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography className={classes.heading}>
                    {index.name}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {index.description}
                  </Typography>
                </AccordionSummary>
                {_size(index.course) === 0 ? (
                  <AccordionDetails>
                    <NormalText>{t('Thiscategoryhasnocourses')}</NormalText>
                  </AccordionDetails>
                ) : (
                  <React.Fragment>
                    {index.course.map(i => {
                      return (
                        <AccordionDetails>
                          <p
                            onClick={() => {
                              setCurrentCourse(i.courseid);
                              setCurrentCourseName(i.name);
                            }}
                          >
                            <a href="#">{i.name}</a>
                          </p>
                        </AccordionDetails>
                      );
                    })}
                  </React.Fragment>
                )}
                <SmallButton
                  onClick={() => {
                    setAddNewCourse(!addNewCourse);
                    setAddNew(false);
                    setAddNewSection(false);
                  }}
                >
                  {t('AddNewCourse')}
                </SmallButton>
                {addNewCourse && (
                  <form className={classes.form} noValidate autoComplete="off">
                    <div>
                      <TextField
                        required
                        id="standard-required"
                        label="Course Name"
                        error={course === ''}
                        onKeyPress={event => {
                          if (event.key === 'Enter') {
                            addCourse(index.categoryid);
                          }
                        }}
                        errorText="Course name is required"
                        value={course}
                        onChange={e => setCourse(e.target.value)}
                      />
                      <TextField
                        required
                        id="standard-required"
                        label="Course Description"
                        onKeyPress={event => {
                          if (event.key === 'Enter') {
                            addCourse(index.categoryid);
                          }
                        }}
                        multiline={true}
                        error={courseDescription === ''}
                        errorText="Course Description is required"
                        value={courseDescription}
                        onChange={e => setCourseDescription(e.target.value)}
                      />
                      {/* <input type="file" onChange={event 

                      => getBase64(event)} />
                      <Button onClick={() => onFileUpload()}>Upload!</Button> */}
                      <Button
                        onClick={() => addCourse(index.categoryid)}
                        variant="contained"
                        color="primary"
                        disabled={course === '' || courseDescription === ''}
                      >
                        ADD
                      </Button>
                    </div>
                  </form>
                )}
              </Accordion>
            );
          })}
        </div>
      </Grid>
    );
  };

  const courseAccordionView = () => {
    const sec = currentCourseObj[0] && currentCourseObj[0].section;
    return (
      <Grid container justify="center">
        <div className={classes.accordion}>
          {_size(sec) === 0 ? (
            <NormalText>{t('Thiscoursehasnosections')}</NormalText>
          ) : (
            <React.Fragment>
              {sec.map((index, key) => {
                return (
                  <Accordion
                    expanded={expanded === `panel${key}`}
                    onChange={handleAccordionChange(`panel${key}`)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography className={classes.heading}>
                        {index.name}
                      </Typography>
                      <Typography className={classes.secondaryHeading}>
                        {index.description}
                      </Typography>
                    </AccordionSummary>
                    {_size(index.lecture) === 0 ? (
                      <AccordionDetails>
                        {t('Thissectionhasnolectures')}
                      </AccordionDetails>
                    ) : (
                      <React.Fragment>
                        {index.lecture.map(i => {
                          return (
                            <AccordionDetails>
                              <a href={i.link} target="_blank">
                                {i.name}
                              </a>
                            </AccordionDetails>
                          );
                        })}
                      </React.Fragment>
                    )}
                    <SmallButton
                      onClick={() => {
                        setAddNewCourse(false);
                        setAddNew(!addNew);
                        setAddNewSection(false);
                      }}
                    >
                      {t('AddNewLecture')}
                    </SmallButton>
                    {addNew && (
                      <form
                        className={classes.form}
                        noValidate
                        autoComplete="off"
                      >
                        <div>
                          <TextField
                            required
                            id="standard-required"
                            label="Lecture Name"
                            value={lectureName}
                            error={lectureName === ''}
                            onKeyPress={event => {
                              if (event.key === 'Enter') {
                                addLecture(index.sectionid);
                              }
                            }}
                            errorText="Lecture name is required"
                            onChange={e => setLecture(e.target.value)}
                          />

                          <TextField
                            required
                            id="standard-required"
                            label="Lecture Link"
                            value={lectureLink}
                            error={lectureLink === ''}
                            onKeyPress={event => {
                              if (event.key === 'Enter') {
                                addLecture(index.sectionid);
                              }
                            }}
                            errorText="Lecture link is required"
                            onChange={e => setLectureLink(e.target.value)}
                          />
                          <div>
                            <TextareaAutosize
                              aria-label="minimum height"
                              rowsMin={3}
                              value={lectureDescription}
                              onKeyPress={event => {
                                if (event.key === 'Enter') {
                                  addLecture(index.sectionid);
                                }
                              }}
                              onChange={e =>
                                setLectureDescription(e.target.value)
                              }
                              placeholder="Enter Lecture Description"
                            />
                          </div>
                        </div>
                        <Button
                          onClick={() => addLecture(index.sectionid)}
                          variant="contained"
                          color="primary"
                          disabled={
                            lectureName === '' ||
                            lectureDescription === '' ||
                            lectureLink === ''
                          }
                        >
                          ADD
                        </Button>
                      </form>
                    )}
                  </Accordion>
                );
              })}
            </React.Fragment>
          )}
        </div>
      </Grid>
    );
  };

  const renderMycourseTable = (index, key) => {
    return (
      <tr>
        <td>{key + 1}</td>
        <td>
          {edit === key ? (
            <>
              <TextareaAutosize
                aria-label="minimum height"
                rowsMin={3}
                style={{ width: 400, height: 150 }}
                value={courseEditName}
                onChange={e => setCourseEditName(e.target.value)}
                placeholder={t('CourseName')}
              />
              <CheckIcon
                onClick={() =>
                  editCourse(
                    courseEditName,
                    courseEditDescription,
                    index.courseid
                  )
                }
              />
              <ClearIcon onClick={() => setEdit(null)} />
            </>
          ) : (
            index.name
          )}
        </td>
        <td>
          {edit === key ? (
            <>
              <TextareaAutosize
                aria-label="minimum height"
                rowsMin={3}
                style={{ width: 400, height: 150 }}
                value={courseEditDescription}
                onChange={e => setCourseEditDescription(e.target.value)}
                placeholder={t('CourseDescription')}
              />
              <CheckIcon
                onClick={() =>
                  editCourse(
                    courseEditName,
                    courseEditDescription,
                    index.courseid
                  )
                }
              />
              <ClearIcon onClick={() => setEdit(null)} />
            </>
          ) : (
            index.description
          )}
        </td>
        <td>
          {index.section.map((sec, secKey) => {
            return (
              <>
                {editSection === secKey && editCourseKey === key ? (
                  <>
                    <TextareaAutosize
                      aria-label="minimum height"
                      rowsMin={3}
                      style={{ width: 400, height: 150 }}
                      value={sectionEditName}
                      onChange={e => setSectionEditName(e.target.value)}
                      placeholder={t('SectionName')}
                    />
                    <TextareaAutosize
                      aria-label="minimum height"
                      rowsMin={3}
                      style={{ width: 400, height: 150 }}
                      value={sectionEditDescription}
                      onChange={e => setSectionEditDescription(e.target.value)}
                      placeholder={t('SectionDescription')}
                    />
                    <CheckIcon
                      onClick={() =>
                        editSectionFunc(
                          sectionEditName,
                          sectionEditDescription,
                          index.courseid,
                          sec.sectionid
                        )
                      }
                    />
                    <ClearIcon onClick={() => setEditSection(null)} />
                  </>
                ) : (
                  <>
                    <p style={{ fontWeight: '800' }}>{sec.name}</p>
                    <p>{sec.description}</p>
                    <EditIcon
                      onClick={() => {
                        setEditSection(secKey);
                        setEditCourseKey(key);
                        setSectionEditName(sec.name);
                        setSectionEditDescription(sec.description);
                      }}
                    />
                    <DeleteIcon
                      onClick={() => {
                        setShowDelete(true);
                        setCurrentSelected({
                          type: 'section',
                          value: sec
                        });
                      }}
                    />
                    <hr />
                  </>
                )}
              </>
            );
          })}
        </td>
        <td>
          {index.section.map((sec, secKey) =>
            sec.lecture.map((lec, lecKey) => {
              return (
                <>
                  {editCourseKey === key && editLecture === lecKey ? (
                    <>
                      <TextareaAutosize
                        aria-label="minimum height"
                        rowsMin={3}
                        style={{ width: 400, height: 150 }}
                        value={lectureEditName}
                        onChange={e => setLectureEditName(e.target.value)}
                        placeholder={t('LectureName')}
                      />
                      <TextareaAutosize
                        aria-label="minimum height"
                        rowsMin={3}
                        style={{ width: 400, height: 150 }}
                        value={lectureEditDescription}
                        onChange={e =>
                          setLectureEditDescription(e.target.value)
                        }
                        placeholder={t('LectureDescription')}
                      />
                      <TextareaAutosize
                        aria-label="minimum height"
                        rowsMin={3}
                        style={{ width: 400, height: 150 }}
                        value={lectureEditLink}
                        onChange={e => setLectureEditLink(e.target.value)}
                        placeholder={t('LectureLink')}
                      />
                      <CheckIcon
                        onClick={() =>
                          editLectureFunc(
                            lectureEditName,
                            lectureEditDescription,
                            lectureEditLink,
                            index.courseid,
                            sec.sectionid,
                            lec.lectureid
                          )
                        }
                      />
                      <ClearIcon onClick={() => setEditLecture(null)} />
                    </>
                  ) : (
                    <>
                      <p style={{ fontWeight: '800' }}>{lec.name}</p>
                      <p>{lec.description}</p>
                      <EditIcon
                        onClick={() => {
                          setEditLecture(lecKey);
                          setEditCourseKey(key);
                          setLectureEditName(lec.name);
                          setLectureEditDescription(lec.description);
                          setLectureEditLink(lec.link);
                        }}
                      />
                      <DeleteIcon
                        onClick={() => {
                          setShowDelete(true);
                          setCurrentSelected({
                            type: 'lecture',
                            value: lec
                          });
                        }}
                      />
                      <hr />
                    </>
                  )}
                </>
              );
            })
          )}
        </td>
        <td>{_get(index, 'adminComment', '')}</td>
        <td>{_get(index, 'courseStatus.status', '')}</td>
        <td>
          {
            <div
              style={{
                display: 'flex',
                flexDirection: 'row'
              }}
            >
              <Typography>{_capitalize(index.coursetype)}</Typography>
              <FlipCameraAndroidIcon
                style={{ marginLeft: 10 }}
                onClick={() => {
                  changeCourseType(index.courseid, index.coursetype);
                }}
              />
            </div>
          }
        </td>
        <td>
          {' '}
          <EditIcon
            onClick={() => {
              setEdit(key);
              setCourseEditName(index.name);
              setCourseEditDescription(index.description);
            }}
          />
          <DeleteIcon
            onClick={() => {
              setShowDelete(true);
              setCurrentSelected({
                type: 'course',
                value: index
              });
            }}
          />
        </td>
      </tr>
    );
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertSuccess(false);
    setAlertFailure(false);
  };

  return (
    <Container>
      <DashboardWrapper>
        <Header setTabIndex={() => setTabIndex(0)} />
      </DashboardWrapper>
      <ContentWrapper>
        <Snackbar
          open={alertFailure}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Toast onClose={handleClose} severity="error">
            {status}
          </Toast>
        </Snackbar>
        <Snackbar
          open={alertSuccess}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Toast onClose={handleClose} severity="success">
            {status}
          </Toast>
        </Snackbar>
        <Snackbar
          open={showDelete}
          autoHideDuration={3000}
          onClose={handleClose}
          message={`Are you sure you want to delete "${_get(
            currentSelected,
            'value.name',
            ''
          )}"?`}
          action={
            <>
              <Button
                onClick={() => {
                  if (currentSelected.type === 'course') {
                    deleteCourse(currentSelected.value);
                  } else if (currentSelected.type === 'section') {
                    deleteSection(currentSelected.value);
                  } else if (currentSelected.type === 'lecture') {
                    deleteLecture(currentSelected.value);
                  }
                }}
                color="inherit"
                size="small"
              >
                DELETE
              </Button>
              <Button
                onClick={() => setShowDelete(false)}
                color="inherit"
                size="small"
              >
                CANCEL
              </Button>
            </>
          }
        />
        <Tabs
          selectedIndex={tabIndex}
          onSelect={index => setTabIndex(index)}
          selectedTabClassName={classes.tabTextColor}
        >
          <TabList style={styles.tabList}>
            <Tab style={styles.tabs}>{t('HOME')}</Tab>
            <Tab style={styles.tabs}>{t('MYCOURSES')}</Tab>
            <Tab style={styles.tabs}>{t('STATISTICS')}</Tab>
          </TabList>
          <TabPanel>
            <React.Fragment>
              <center>
                {currentCourse !== null && (
                  <p
                    onClick={() => {
                      setCurrentCourse(null);
                      setAddNewSection(false);
                      setAddNew(false);
                    }}
                  >
                    <a href="#">Go Back</a>
                  </p>
                )}
                {currentCourse === null ? (
                  <WideNormalText>
                    {t('Pleasechooseacategorytoaddacourse')}
                  </WideNormalText>
                ) : (
                  <React.Fragment>
                    <h2>{currentCourseName}</h2>
                    <NormalText>
                      {t('Pleasechooseasectiontoaddalecture')}
                    </NormalText>
                    <SmallButton
                      onClick={() => {
                        setAddNewSection(!addNewSection);
                      }}
                    >
                      {t('AddSection')}
                    </SmallButton>
                  </React.Fragment>
                )}

                {addNewSection && (
                  <form className={classes.form} noValidate autoComplete="off">
                    <div>
                      <TextField
                        required
                        id="standard-required"
                        label="Section Name"
                        error={section === ''}
                        errorText="Section name is required"
                        value={section}
                        onKeyPress={event => {
                          if (event.key === 'Enter') {
                            addSection();
                          }
                        }}
                        onChange={e => setSection(e.target.value)}
                      />
                      <div>
                        <TextareaAutosize
                          aria-label="minimum height"
                          rowsMin={3}
                          value={sectionDescription}
                          onKeyPress={event => {
                            if (event.key === 'Enter') {
                              addSection();
                            }
                          }}
                          onChange={e => setSectionDescription(e.target.value)}
                          placeholder="Enter Section Description"
                        />
                        <div>
                          <Button
                            onClick={() => addSection()}
                            variant="contained"
                            color="primary"
                            disabled={
                              section === '' || sectionDescription === ''
                            }
                          >
                            ADD
                          </Button>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
                {currentCourse === null
                  ? categoryAccordionView()
                  : courseAccordionView()}
              </center>
            </React.Fragment>
          </TabPanel>
          <TabPanel>
            <TableWrapper>
              <NormalText>{t('Checkthestatusofyourcourses')}</NormalText>
              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{t('Name')}</th>
                    <th>{t('Description')}</th>
                    <th>{t('Sections')}</th>
                    <th>{t('Lectures')}</th>
                    <th>{t('AdminComment')}</th>
                    <th>{t('Status')}</th>
                    <th>
                      <AttachMoneyIcon />
                    </th>
                    <th>{t('Actions')}</th>
                  </tr>
                </thead>
                <tbody>
                  {myCourses.map((index, key) => {
                    return <>{renderMycourseTable(index, key)}</>;
                  })}
                </tbody>
              </Table>
            </TableWrapper>
          </TabPanel>
          <TabPanel>
            <center>
              <Grid container item xs={12} spacing={3}>
                <Grid item xs={6}>
                  <Card
                    style={{ marginLeft: 40, marginRight: 40, height: 130 }}
                    className={classes.root}
                  >
                    <CardContent>
                      <Typography variant="h5" component="h2">
                        {t('TotalLectures')}
                      </Typography>
                      <FontAwesomeIcon size="2x" icon={faChalkboardTeacher} />
                      <Typography variant="h5" component="h2">
                        {_size(currentLectures)}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card
                    style={{ marginLeft: 40, marginRight: 40, height: 130 }}
                    className={classes.root}
                  >
                    <CardContent>
                      <Typography variant="h5" component="h2">
                        {t('TotalCourses')}
                      </Typography>
                      <FontAwesomeIcon size="2x" icon={faBookOpen} />
                      <Typography variant="h5" component="h2">
                        {_size(myCourses)}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card
                    style={{ marginLeft: 40, marginRight: 40, height: 130 }}
                    className={classes.root}
                  >
                    <CardContent>
                      <Typography variant="h5" component="h2">
                        {t('TotalSections')}
                      </Typography>
                      <FontAwesomeIcon size="2x" icon={faPuzzlePiece} />
                      <Typography variant="h5" component="h2">
                        {_size(currentSections)}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card
                    style={{ marginLeft: 40, marginRight: 40, height: 130 }}
                    className={classes.root}
                  >
                    <CardContent>
                      <Typography variant="h5" component="h2">
                        {t('TotalCategories')}
                      </Typography>
                      <FontAwesomeIcon size="2x" icon={faChalkboard} />
                      <Typography variant="h5" component="h2">
                        {_size(currentCategories)}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </center>
          </TabPanel>
        </Tabs>
      </ContentWrapper>
      {/* <VideoModal
        show={videoModalShow}
        onHide={() => setVideoModalShow(false)}
      /> */}
      {/* <SuccessModal
        show={successModalShow}
        onHide={() => setSuccessModalShow(false)}
      /> */}
    </Container>
  );
}
